import axios from "axios";
import { config } from "@/config";

const GIFT_API_BASE_URL = config.GIFT_API_BASE_URL;
const GIFT_API_KEY = config.GIFT_API_KEY;

export interface CampaignDetailsPayload {
  p_Id: number;
  p_CampaignName: string;
  p_StartDate: string;
  p_EndDate: string;
  p_CampaignType: "MessageOnly" | "PrepaidPointBase";
  p_BonusPoints: number;
  p_CreatedBy: number;
  p_UpdatedBy: number;
}

export interface MessageConfigPayload {
  communicationType: "SMS" | "WhatsApp" | "Email";
  messageType: string;
  templateId: number;
  messageSentDate: string;
  messageText: string;
}

export interface CreateUpdateCampaignRequest {
  campaignDetails: CampaignDetailsPayload;
  listMsgConfig: MessageConfigPayload[];
}

export interface CreateUpdateCampaignResponse {
  message?: string;
  error_msg?: string;
  [key: string]: any;
}

export interface GetAllCampaignItem {
  id: number;
  campaignName: string;
  startDate: string;
  endDate: string;
  campaignType: string;
  bonusPoints: number;
  createdDateTime: string;
  createdBy: number;
  updatedDateTime: string;
  updatedBy: number;
}

export interface GetAllCampaignMessageItem {
  id: number;
  communicationType: "SMS" | "WhatsApp" | "EMAIL" | "Email";
  messageType: string;
  templateId: string;
  messageSentDate: string;
  messageText: string;
  campaignId: number;
}

export interface GetAllCampaignsResponse {
  getAllCampaign: GetAllCampaignItem[];
  listCampaignMessage: GetAllCampaignMessageItem[];
  error_msg?: string;
}

export class CampaignApi {
  static async createUpdateCampaign(
    payload: CreateUpdateCampaignRequest
  ): Promise<CreateUpdateCampaignResponse> {
    try {
      const response = await axios.post<CreateUpdateCampaignResponse>(
        `${GIFT_API_BASE_URL}/Campaign/CreateUpdateCampaign`,
        payload,
        {
          headers: {
            xapikey: GIFT_API_KEY,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async getAllCampaigns(): Promise<GetAllCampaignsResponse> {
    try {
      const response = await axios.post<GetAllCampaignsResponse>(
        `${GIFT_API_BASE_URL}/Campaign/GetAllCampaigns`,
        {},
        {
          headers: {
            xapikey: GIFT_API_KEY,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

